<!-- TEMPLATE -->
<template>
  <transition name="fade" mode="out-in">
    <div class="dean-alert-dialog-container">
      <div :class="deanAlertDialogClass" class="row">
         <div
          v-if="data.icon"
          class="all-1-half columns info-icon">
          <dean-icon  :glyph="data.icon" width="15"></dean-icon>
        </div>
        <div
          v-else
          class="all-1-half columns info-icon">
          <dean-icon  :glyph="alertIcon" width="15"></dean-icon>
        </div>
        <div :class="deanAlertDialogTextClass">
          <span class="alert-text header" v-if="data.title">{{ data.title }}</span>
          <span class="alert-text sub-header">{{ data.text }}</span>
        </div>
        <div v-if="closeable" class="all-1-half columns close-icon" @click="closeClick">
          <dean-icon :glyph="closeIcon" width="15"></dean-icon>
        </div>
      </div>
    </div>
  </transition>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

// SVG
import {
  // SVG
  emptyIcon,
  closeIcon,
  // COMPONENTS
} from '@deanone/dean-components';
import deanIcon from './deanIcon.vue';


@Component({
  components: {
    deanIcon
  }
})

export default class deanAlertDialog extends Vue {
  // PROPS
  @Prop() data!: object;
  @Prop() theme!:  string;
  @Prop({ default: false }) standard!: boolean;
  @Prop({ default: false }) success!:  boolean;
  @Prop({ default: false }) info!: boolean;
  @Prop({ default: false }) warning!:  boolean;
  @Prop({ default: false }) danger!: boolean;
  @Prop({ default: true }) closeable!: boolean;

  // DATA
  closeIcon: object = closeIcon;
  alertIcon: object = emptyIcon;
  close: boolean = false;

  // EMITS
  @Emit('close') closeClick() {}

  // COMPUTED
  get deanAlertDialogClass() {
    let value = 'dean-alert-dialog';
    if (this.standard) value += ` dean-alert-dialog-standard`;
    else if (this.success) value += ` dean-alert-dialog-success`;
    else if (this.info) value += ` dean-alert-dialog-info`;
    else if (this.warning) value += ` dean-alert-dialog-warning`;
    else if (this.danger) value += ` dean-alert-dialog-danger`;
    else  value += `  dean-alert-dialog-standard`;
    if (this.theme) {
      value += `  dean-alert-dialog-${this.theme}`
    }
    return value
  }

  get deanAlertDialogTextClass() {
    let value = 'columns dean-alert-dialog-text';
    if (this.closeable) value += ' all-9';
    else value += ' all-10-half';

    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

.dean-alert-dialog-container {
  /* position: fixed;
  top: 90px;
  @include calc(left,"50% - 160px");
  z-index: 999; */
  padding: 5px 10px 5px 10px;

  .dean-alert-dialog {
    @include display-flex();
    align-items: center;
    justify-content: flex-start;
    @include border-radius(10px);
    z-index: 999;
    padding: 10px;
    width: 100%;
    text-align: center;

    .info-icon,
    .close-icon {
      display: flex;
      height: 20px;
      cursor: pointer;
    }
    .info-icon {
      justify-content: flex-start;
      align-self: flex-start;
    }
    .close-icon {
      justify-content: flex-end;
      align-self: flex-start;
    }

    .dean-alert-dialog-text {
      overflow-wrap: break-word;
      @include hyphens(auto);
    }
  }
  .dean-alert-dialog-standard {
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    fill: var(--color-dark-shade-4, $color-dark-shade-4);
    background: var(--color-light-shade-2, $color-light-shade-2);
    border: 1px solid var(--color-light, $color-light);
  }

  .dean-alert-dialog-success {
    color: var(--color-info-success, $color-info-success);
    fill: var(--color-info-success, $color-info-success);
    background: var(--color-info-success-bg, $color-info-success-bg);
    border: 1px solid var(--color-info-success-border, $color-info-success-border);
  }

  .dean-alert-dialog-info {
    color: var(--color-info-standard, $color-info-standard);
    fill: var(--color-info-standard, $color-info-standard);
    background: var(--color-info-standard-bg, $color-info-standard-bg);
    border: 1px solid var(--color-info-standard-border, $color-info-standard-border);
  }

  .dean-alert-dialog-warning {
    color: var(--color-info-warning, $color-info-warning);
    fill: var(--color-info-warning, $color-info-warning);
    background: var(--color-info-warning-bg, $color-info-warning-bg);
    border: 1px solid var(--color-info-warning-border, $color-info-warning-border);
  }

  .dean-alert-dialog-danger {
    color: var(--color-info-danger, $color-info-danger);
    fill: var(--color-info-danger, $color-info-danger);
    background: var(--color-info-danger-bg, $color-info-danger-bg);
    border: 1px solid var(--color-info-danger-border, $color-info-danger-border);
  }

  .alert-text {
    display: block;
    &.header {
      font-weight: bold;
      font-size: $font-large;
    }
  }
}
</style>
